module.exports = __webpack_public_path__ + "static/media/loading.0c56ee55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/style/images/loading.svg
// module id = 2344
// module chunks = 0